import React from 'react'
import PropTypes from 'prop-types'
import { formatDuration } from '../../utils'

import './TimerComponent.scss'

class TimerComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      secondsElapsed: 0,
    }
  }

  componentDidMount() {
    this.onTick()
    this.interval = setInterval(this.onTick.bind(this), 1000)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { seconds } = this.props
    if (nextProps.seconds !== seconds) {
      this.setState({ secondsElapsed: 0 })
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  onTick() {
    this.setState((state) => ({
      secondsElapsed: state.secondsElapsed + 1,
    }))
  }

  render() {
    const { seconds } = this.props
    const { secondsElapsed } = this.state

    return (
      <div className="timer-component">
        {formatDuration(seconds + secondsElapsed)}
      </div>
    )
  }
}

TimerComponent.propTypes = {
  seconds: PropTypes.number,
}

export default TimerComponent
